/**
 * Disables the theme's native cart drawer (setting: cart_disable_native).
 *
 * The theme auto-opens <cart-drawer> on `variant:add` (CartDrawer's cart-change
 * handler calls show() when cartType is "drawer" or a product-card passes
 * on_success=force_open_drawer). With Rebuy Smart Cart also opening on add, both
 * carts appear. The cart icon is already handled by Rebuy, so the drawer's only
 * unwanted appearance is this auto-open — neutralising show() suppresses it.
 */
(function () {
  'use strict';

  function disable(drawer) {
    if (!drawer || drawer.dataset.nativeDisabled) return;
    drawer.dataset.nativeDisabled = 'true';
    drawer.show = function () {};
    if (drawer.hasAttribute('open')) drawer.removeAttribute('open');
  }

  function start() {
    disable(document.getElementById('cart-drawer'));
    // The drawer is re-rendered on cart change, so re-apply if it's replaced.
    new MutationObserver(function () {
      disable(document.getElementById('cart-drawer'));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
